import { ORCHESTRATION_SERVICE_API } from '../constants/AppConstants';

/**
 * Service to get image blob using image token
 * @param {string} imageToken - The image token to fetch
 * @returns {Promise} - API response promise with blob data
 */
const getImageBlobService = async (imageToken) => {
  try {
    const response = await fetch(`${ORCHESTRATION_SERVICE_API}/v1/image/${imageToken}`, {
      method: 'GET',
    });

    if (response.status !== 200) {
      return { ok: false, status: response.status, error: 'Failed to fetch image' };
    }

    const blob = await response.blob();
    const imageUrl = URL.createObjectURL(blob);

    return { ok: true, imageUrl, blob };
  } catch (error) {
    return { ok: false, error: error.message };
  }
};

export default getImageBlobService;
